import { Button, Tooltip } from "@fluentui/react-components";
import { InfoRegular } from "@fluentui/react-icons";
import {
  Cell,
  CellTemplate,
  Compatible,
  Uncertain,
  getCellProperty,
} from "@silevis/reactgrid";
import * as React from "react";

export interface ClientSaldoEntryInfoCell extends Cell {
  type: "clientsaldoentryinfo";
  paymentId?: any;
  showButton?: boolean;
  highlighted?: boolean;
  infoFn?: any;
  t: any;
}

export class ClientSaldoEntryInfoCellTemplate
  implements CellTemplate<ClientSaldoEntryInfoCell>
{
  getCompatibleCell(
    uncertainCell: Uncertain<ClientSaldoEntryInfoCell>
  ): Compatible<ClientSaldoEntryInfoCell> {
    const t = getCellProperty(uncertainCell, "t", "function");

    let paymentId: any;
    try {
      paymentId = getCellProperty(uncertainCell, "paymentId", "number");
    } catch {
      paymentId = undefined;
    }

    let showButton = false;
    try {
      showButton = getCellProperty(uncertainCell, "showButton", "boolean");
    } catch {
      showButton = false;
    }

    let highlighted = false;
    try {
      highlighted = getCellProperty(uncertainCell, "highlighted", "boolean");
    } catch {
      highlighted = false;
    }

    let infoFn: any;
    try {
      infoFn = getCellProperty(uncertainCell, "infoFn", "function");
    } catch {
      infoFn = undefined;
    }

    return {
      ...uncertainCell,
      paymentId,
      showButton,
      highlighted,
      infoFn,
      text: "",
      value: NaN,
      t,
    };
  }

  getClassName(
    cell: Compatible<ClientSaldoEntryInfoCell>,
    isInEditMode: boolean
  ): string {
    return (
      (cell.className ? cell.className : "") +
      (cell.highlighted ? " highlighted-selected-row" : "")
    );
  }

  render(
    cell: Compatible<ClientSaldoEntryInfoCell>,
    isInEditMode: boolean,
    onCellChanged: (
      cell: Compatible<ClientSaldoEntryInfoCell>,
      commit: boolean
    ) => void
  ): React.ReactNode {
    return <InfoButtonCell cell={cell} />;
  }
}

interface DIProps {
  cell: Record<string, any>;
}

const InfoButtonCell: React.FC<DIProps> = ({ cell }) => {
  if (!cell.showButton) {
    return <div style={{ width: "100%", textAlign: "center" }} />;
  }
  return (
    <div style={{ width: "100%", textAlign: "center" }}>
      <Tooltip
        content={cell.t("pct.paymentsByClientSaldoEntry.label")}
        relationship="label"
      >
        <Button
          data-help="client-balance-info-entry-payments"
          appearance="subtle"
          size="small"
          icon={<InfoRegular />}
          onClick={() => {
            cell.infoFn && cell.infoFn();
          }}
        />
      </Tooltip>
    </div>
  );
};
